import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.report');
import { OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const targetRangeBandPlugin = {
    id: 'targetRangeBand',
    beforeDraw(chart: any) {
        const ctx = chart.ctx;
        const yAxis = chart.scales.y;
        const xAxis = chart.scales.x;
        if (!yAxis || !xAxis) return;
        const y180 = yAxis.getPixelForValue(180);
        const y70 = yAxis.getPixelForValue(70);
        ctx.save();
        ctx.fillStyle = 'rgba(22, 163, 106, 0.08)';
        ctx.fillRect(xAxis.left, y180, xAxis.right - xAxis.left, y70 - y180);
        ctx.restore();
    }
};

const midnightLinesPlugin = {
    id: 'midnightLines',
    afterDraw(chart: any) {
        const indices: number[] = (chart as any)._midnightIndices || [];
        if (!indices.length) return;
        const ctx = chart.ctx;
        const xAxis = chart.scales.x;
        const yAxis = chart.scales.y;
        ctx.save();
        ctx.strokeStyle = 'rgba(100, 116, 139, 0.4)';
        ctx.lineWidth = 1;
        for (const idx of indices) {
            const x = xAxis.getPixelForValue(idx);
            if (x >= xAxis.left && x <= xAxis.right) {
                ctx.beginPath();
                ctx.moveTo(x, yAxis.top);
                ctx.lineTo(x, yAxis.bottom);
                ctx.stroke();
            }
        }
        ctx.restore();
    }
};

@Component({
    selector: 'wiz-page-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.report/view.scss */
@charset "UTF-8";
:host {
  display: block;
  width: 100%;
  height: 100%;
}

@media print {
  :host {
    height: auto !important;
    overflow: visible !important;
    display: block !important;
  }
  .no-print {
    display: none !important;
  }
  /* 스크롤바 완전 숨김 */
  * {
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }
  *::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
  }
  /* 모든 높이/스크롤 제한 해제 */
  .h-full,
  .flex-1,
  .min-h-0,
  .overflow-auto {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    flex: none !important;
    min-height: auto !important;
  }
  /* 콘텐츠 최대 너비 해제 */
  .max-w-4xl,
  .max-w-5xl {
    max-width: 100% !important;
  }
  /* 섹션 잘림 방지 */
  .bg-white,
  .rounded-lg {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  canvas {
    break-inside: avoid;
    page-break-inside: avoid;
    max-width: 100% !important;
  }
  .space-y-4 > div,
  .space-y-6 > div {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
}`],
})
export class PageReportComponent implements OnInit, AfterViewInit {
    @ViewChild('tirChart') tirChartRef: ElementRef;
    @ViewChild('agpChart') agpChartRef: ElementRef;
    @ViewChild('glucoseChart') glucoseChartRef: ElementRef;
    @ViewChild('dailyTirChart') dailyTirChartRef: ElementRef;
    @ViewChild('histogramChart') histogramChartRef: ElementRef;
    @ViewChild('hourlyChart') hourlyChartRef: ElementRef;
    @ViewChild('variabilityChart') variabilityChartRef: ElementRef;

    constructor(@Inject( Service) public service: Service) { }

    public upload: any = null;
    public summary: any = null;
    public advanced: any = null;
    public loading: boolean = true;
    public dailyStats: any[] = [];
    public filledDailyStats: any[] = [];
    public hypoEvents: any[] = [];
    public hyperEvents: any[] = [];
    public uploadId: string = '';
    private charts: any[] = [];

    // Period selection
    public periodMode: string = 'all';
    public customStartDate: string = '';
    public customEndDate: string = '';
    public filteredDataCount: number = 0;
    public selectedPeriodStart: string = '';
    public selectedPeriodEnd: string = '';
    public customApplied: boolean = false;
    public periodPresets = [
        { label: '전체', value: 'all' },
        { label: '7일', value: '7d' },
        { label: '14일', value: '14d' },
        { label: '30일', value: '30d' },
        { label: '60일', value: '60d' },
        { label: '90일', value: '90d' },
        { label: '기간 선택', value: 'custom' }
    ];

    // Glucose chart scroll state
    private glucoseFullRows: any[] = [];
    private glucoseDayBounds: { day: string, startIdx: number }[] = [];
    public glucoseTotalDays: number = 0;
    public glucoseScrollPos: number = 0;
    public glucoseScrollMax: number = 0;
    private glucoseChartInstance: any = null;
    private readonly glucoseWindowDays: number = 10;

    // Variability chart scroll state
    public variabilityScrollPos: number = 0;
    public variabilityScrollMax: number = 0;
    private variabilityChartInstance: any = null;

    // Daily TIR chart scroll state
    public dailyTirScrollPos: number = 0;
    public dailyTirScrollMax: number = 0;
    private dailyTirChartInstance: any = null;

    public async ngOnInit() {
        await this.service.init();
        this.uploadId = WizRoute.segment.id;
        if (!this.uploadId) {
            this.service.href('/dashboard');
            return;
        }
        await this.loadData();
    }

    public ngAfterViewInit() { }

    private async loadData() {
        this.loading = true;
        await this.service.render();

        let { code, data } = await wiz.call("load", { id: this.uploadId });
        if (code !== 200) {
            this.service.href('/dashboard');
            return;
        }
        this.upload = data.upload;
        this.filteredDataCount = this.upload?.data_count || 0;
        this.selectedPeriodStart = (this.upload?.period_start || '').toString().substring(0, 10);
        this.selectedPeriodEnd = (this.upload?.period_end || '').toString().substring(0, 10);
        this.customStartDate = this.selectedPeriodStart;
        this.customEndDate = this.selectedPeriodEnd;

        let [summaryRes, statsRes, eventsRes, advancedRes] = await Promise.all([
            wiz.call("summary", { id: this.uploadId }),
            wiz.call("daily_stats", { id: this.uploadId }),
            wiz.call("events", { id: this.uploadId }),
            wiz.call("advanced", { id: this.uploadId })
        ]);

        if (summaryRes.code === 200) {
            this.summary = summaryRes.data.summary || {};
            this.filteredDataCount = summaryRes.data.data_count || 0;
            this.selectedPeriodStart = summaryRes.data.period_start || '';
            this.selectedPeriodEnd = summaryRes.data.period_end || '';
        }

        if (statsRes.code === 200) {
            this.dailyStats = statsRes.data.stats || [];
            this.filledDailyStats = this.fillDailyGaps(this.dailyStats);
        }
        if (eventsRes.code === 200) {
            this.hypoEvents = (eventsRes.data.hypo || []).reverse();
            this.hyperEvents = (eventsRes.data.hyper || []).reverse();
        }
        if (advancedRes.code === 200) this.advanced = advancedRes.data.data || {};

        this.loading = false;
        await this.service.render();

        setTimeout(async () => {
            await this.renderTirChart();
            await this.renderHistogramChart();
            await this.renderAgpChart();
            await this.renderHourlyChart();
            await this.renderGlucoseChart();
            await this.renderVariabilityChart();
            await this.renderDailyTirChart();
        }, 100);
    }

    // ==============================================
    // 데이터 갭 처리 헬퍼
    // ==============================================
    private fillDailyGaps(stats: any[]): any[] {
        if (stats.length < 2) return [...stats];
        const filled: any[] = [];
        for (let i = 0; i < stats.length; i++) {
            filled.push(stats[i]);
            if (i < stats.length - 1) {
                const curDate = new Date(stats[i].date + 'T00:00:00');
                const nextDate = new Date(stats[i + 1].date + 'T00:00:00');
                const diffDays = Math.round((nextDate.getTime() - curDate.getTime()) / (1000 * 60 * 60 * 24));
                if (diffDays > 1) {
                    for (let offset = 1; offset < diffDays; offset++) {
                        const blankDate = new Date(curDate);
                        blankDate.setDate(blankDate.getDate() + offset);
                        const y = blankDate.getFullYear();
                        const m = String(blankDate.getMonth() + 1).padStart(2, '0');
                        const d = String(blankDate.getDate()).padStart(2, '0');
                        const blankDateStr = `${y}-${m}-${d}`;
                        filled.push({
                            date: blankDateStr,
                            min: null, max: null, mean: null,
                            sd: null, tir_target: null, count: 0, _gap: true
                        });
                    }
                }
            }
        }
        return filled;
    }

    private processGlucoseGaps() {
        if (!this.glucoseFullRows.length || !this.glucoseDayBounds.length) return;

        // 1. 가장 데이터가 많은 날 기준으로 POINTS_PER_DAY 결정
        let POINTS_PER_DAY = 0;
        for (let d = 0; d < this.glucoseDayBounds.length; d++) {
            const nextStart = d + 1 < this.glucoseDayBounds.length
                ? this.glucoseDayBounds[d + 1].startIdx
                : this.glucoseFullRows.length;
            const cnt = nextStart - this.glucoseDayBounds[d].startIdx;
            if (cnt > POINTS_PER_DAY) POINTS_PER_DAY = cnt;
        }
        if (POINTS_PER_DAY === 0) return;

        // 2. 슬롯 간격 (분)
        const INTERVAL_MINUTES = (24 * 60) / POINTS_PER_DAY;

        // 3. 실제 데이터 날짜별로 행 그룹화
        const dayDataMap = new Map<string, any[]>();
        for (let d = 0; d < this.glucoseDayBounds.length; d++) {
            const curBound = this.glucoseDayBounds[d];
            const nextBound = d + 1 < this.glucoseDayBounds.length ? this.glucoseDayBounds[d + 1] : null;
            const endIdx = nextBound ? nextBound.startIdx : this.glucoseFullRows.length;
            dayDataMap.set(curBound.day, this.glucoseFullRows.slice(curBound.startIdx, endIdx));
        }

        // 4. 첫날~마지막날 전체 범위에서 고정 타임그리드 생성
        const firstDay = this.glucoseDayBounds[0].day;
        const lastDay = this.glucoseDayBounds[this.glucoseDayBounds.length - 1].day;
        const firstDate = new Date(firstDay + 'T00:00:00');
        const lastDate = new Date(lastDay + 'T00:00:00');
        const totalDays = Math.round((lastDate.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

        const newRows: any[] = [];
        const newDayBounds: { day: string, startIdx: number, isGap?: boolean }[] = [];

        for (let di = 0; di < totalDays; di++) {
            const curDate = new Date(firstDate);
            curDate.setDate(curDate.getDate() + di);
            const y = curDate.getFullYear();
            const mo = String(curDate.getMonth() + 1).padStart(2, '0');
            const dd = String(curDate.getDate()).padStart(2, '0');
            const dayStr = `${y}-${mo}-${dd}`;
            const isGap = !dayDataMap.has(dayStr);

            newDayBounds.push({ day: dayStr, startIdx: newRows.length, isGap });

            // 고정 슬롯 배열 생성 (모두 null)
            const slots: (number | null)[] = new Array(POINTS_PER_DAY).fill(null);

            if (!isGap) {
                // 각 데이터 포인트를 시간대 슬롯에 배치
                for (const row of dayDataMap.get(dayStr)!) {
                    if (row.g == null) continue;
                    const timeStr = (row.t || '').substring(11, 16); // "HH:MM"
                    const parts = timeStr.split(':');
                    const hh = parseInt(parts[0], 10);
                    const mm = parseInt(parts[1], 10);
                    if (isNaN(hh) || isNaN(mm)) continue;
                    const minuteOfDay = hh * 60 + mm;
                    const slotIdx = Math.min(Math.round(minuteOfDay / INTERVAL_MINUTES), POINTS_PER_DAY - 1);
                    slots[slotIdx] = row.g;
                }
            }

            // 슬롯을 행으로 변환
            for (let p = 0; p < POINTS_PER_DAY; p++) {
                const slotMin = Math.round(p * INTERVAL_MINUTES);
                const hh = String(Math.floor(slotMin / 60)).padStart(2, '0');
                const mm = String(slotMin % 60).padStart(2, '0');
                newRows.push({ t: `${dayStr} ${hh}:${mm}`, g: slots[p], ...(isGap ? { _gap: true } : {}) });
            }
        }

        this.glucoseFullRows = newRows;
        this.glucoseDayBounds = newDayBounds;
        this.glucoseTotalDays = newDayBounds.length;
        this.glucoseScrollMax = Math.max(0, this.glucoseTotalDays - this.glucoseWindowDays);
        this.glucoseScrollPos = this.glucoseScrollMax;
    }

    // ==============================================
    // TIR 가로 바
    // ==============================================
    private async renderTirChart() {
        if (!this.tirChartRef?.nativeElement) return;
        const tir = this.summary?.tir;
        if (!tir) return;
        const ctx = this.tirChartRef.nativeElement.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: ['TIR'],
                datasets: [
                    { label: '매우 낮음 (<54)', data: [tir.very_low], backgroundColor: '#991b1b', barPercentage: 1.0, categoryPercentage: 1.0 },
                    { label: '낮음 (54-69)', data: [tir.low], backgroundColor: '#ea580c', barPercentage: 1.0, categoryPercentage: 1.0 },
                    { label: '목표 (70-180)', data: [tir.target], backgroundColor: '#16a34a', barPercentage: 1.0, categoryPercentage: 1.0 },
                    { label: '높음 (181-250)', data: [tir.high], backgroundColor: '#eab308', barPercentage: 1.0, categoryPercentage: 1.0 },
                    { label: '매우 높음 (>250)', data: [tir.very_high], backgroundColor: '#dc2626', barPercentage: 1.0, categoryPercentage: 1.0 }
                ]
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false }, tooltip: { callbacks: { label: (c: any) => `${c.dataset.label}: ${c.raw}%` } } },
                scales: { x: { stacked: true, max: 100, display: false }, y: { stacked: true, display: false } }
            }
        });
        this.charts.push(chart);
    }

    // ==============================================
    // 혈당 분포 히스토그램
    // ==============================================
    private async renderHistogramChart() {
        if (!this.histogramChartRef?.nativeElement || !this.advanced?.distribution) return;
        const dist = this.advanced.distribution;
        const ctx = this.histogramChartRef.nativeElement.getContext('2d');

        const colors = dist.labels.map((l: string) => {
            const v = parseInt(l);
            if (v < 54) return '#991b1b';
            if (v < 70) return '#ea580c';
            if (v <= 180) return '#16a34a';
            if (v <= 250) return '#eab308';
            return '#dc2626';
        });

        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: dist.labels,
                datasets: [{ data: dist.counts, backgroundColor: colors, borderWidth: 0 }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false }, tooltip: { callbacks: { title: (items: any) => `${items[0].label}-${parseInt(items[0].label)+10} mg/dL`, label: (c: any) => `${c.raw}건` } } },
                scales: {
                    x: { title: { display: true, text: 'mg/dL', font: { size: 10 } }, ticks: { maxTicksLimit: 15, font: { size: 9 } } },
                    y: { title: { display: true, text: '빈도', font: { size: 10 } }, ticks: { font: { size: 9 } } }
                }
            }
        });
        this.charts.push(chart);
    }

    // ==============================================
    // 시간대별 혈당 분포 (범위 바 + 라인)
    // ==============================================
    private async renderHourlyChart() {
        if (!this.hourlyChartRef?.nativeElement || !this.advanced?.hourly) return;
        const hourly = this.advanced.hourly;
        const ctx = this.hourlyChartRef.nativeElement.getContext('2d');

        const labels = hourly.map((h: any) => `${h.hour}시`);
        const medians = hourly.map((h: any) => h.median);
        const p25 = hourly.map((h: any) => h.p25);
        const p75 = hourly.map((h: any) => h.p75);
        const mins = hourly.map((h: any) => h.min);
        const maxs = hourly.map((h: any) => h.max);

        const chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels,
                datasets: [
                    { label: '최고', data: maxs, borderColor: 'rgba(239,68,68,0.55)', backgroundColor: 'transparent', borderWidth: 1.5, borderDash: [3, 3], pointRadius: 0, fill: false },
                    { label: '75th', data: p75, borderColor: 'transparent', backgroundColor: 'rgba(99,102,241,0.15)', pointRadius: 0, fill: '+2' },
                    { label: '중앙값', data: medians, borderColor: 'rgba(79,70,229,0.65)', borderWidth: 2.5, backgroundColor: 'transparent', pointRadius: 2, pointBackgroundColor: 'rgba(79,70,229,0.65)', fill: false },
                    { label: '25th', data: p25, borderColor: 'transparent', backgroundColor: 'rgba(99,102,241,0.15)', pointRadius: 0, fill: '-2' },
                    { label: '최저', data: mins, borderColor: 'rgba(239,68,68,0.55)', backgroundColor: 'transparent', borderWidth: 1.5, borderDash: [3, 3], pointRadius: 0, fill: false }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 10 }, filter: (item: any) => ['중앙값', '75th', '25th'].includes(item.text) } } },
                scales: {
                    x: { ticks: { font: { size: 10 } } },
                    y: { min: 40, max: 450, ticks: { stepSize: 50, font: { size: 10 } }, title: { display: true, text: 'mg/dL', font: { size: 11 } } }
                }
            }
        });
        this.charts.push(chart);
    }

    // ==============================================
    // AGP
    // ==============================================
    private async renderAgpChart() {
        if (!this.agpChartRef?.nativeElement) return;
        const ctx = this.agpChartRef.nativeElement.getContext('2d');

        let { code, data } = await wiz.call("agp", this.getPeriodParams());
        if (code !== 200) return;
        const agp = data.agp || [];

        const labels = agp.map((a: any) => a.time);
        const chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels,
                datasets: [
                    { label: '95th', data: agp.map((a: any) => a.p95), borderColor: 'transparent', backgroundColor: 'rgba(59,130,246,0.08)', fill: '+4', pointRadius: 0 },
                    { label: '75th', data: agp.map((a: any) => a.p75), borderColor: 'transparent', backgroundColor: 'rgba(59,130,246,0.15)', fill: '+2', pointRadius: 0 },
                    { label: 'Median', data: agp.map((a: any) => a.p50), borderColor: '#2563eb', borderWidth: 2.5, backgroundColor: 'transparent', fill: false, pointRadius: 0 },
                    { label: '25th', data: agp.map((a: any) => a.p25), borderColor: 'transparent', backgroundColor: 'rgba(59,130,246,0.15)', fill: '-2', pointRadius: 0 },
                    { label: '5th', data: agp.map((a: any) => a.p5), borderColor: 'transparent', backgroundColor: 'rgba(59,130,246,0.08)', fill: '-4', pointRadius: 0 }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: {
                    x: { ticks: { maxTicksLimit: 12, font: { size: 10 } } },
                    y: { min: 40, max: 450, ticks: { stepSize: 50, font: { size: 10 } }, title: { display: true, text: 'mg/dL', font: { size: 11 } } }
                }
            }
        });
        this.charts.push(chart);
    }

    // ==============================================
    // 전체 혈당 추이 (7일 윈도우 + 0시 세로선)
    // ==============================================
    private async renderGlucoseChart() {
        if (!this.glucoseChartRef?.nativeElement) return;
        const ctx = this.glucoseChartRef.nativeElement.getContext('2d');

        let { code, data } = await wiz.call("daily_glucose", this.getPeriodParams());
        if (code !== 200) return;
        const rows = data.data || [];
        const step = Math.max(1, Math.floor(rows.length / 2000));
        const sampled = rows.filter((_: any, i: number) => i % step === 0);

        this.glucoseFullRows = sampled;

        // Find day boundaries
        this.glucoseDayBounds = [];
        let prevDay = '';
        for (let i = 0; i < sampled.length; i++) {
            const day = sampled[i].t?.substring(0, 10) || '';
            if (day !== prevDay) {
                this.glucoseDayBounds.push({ day, startIdx: i });
                prevDay = day;
            }
        }
        this.glucoseTotalDays = this.glucoseDayBounds.length;
        this.processGlucoseGaps();

        const { labels, values, midnightIndices } = this.getGlucoseWindow(this.glucoseScrollPos);

        const segmentColor = (ctx: any) => {
            const v = ctx.p1.parsed.y;
            if (v == null) return 'transparent';
            if (v < 54) return '#991b1b';
            if (v < 70) return '#ea580c';
            if (v <= 180) return '#16a34a';
            if (v <= 250) return '#eab308';
            return '#dc2626';
        };

        this.glucoseChartInstance = new Chart(ctx, {
            type: 'line',
            data: {
                labels,
                datasets: [{
                    label: '혈당',
                    data: values,
                    borderColor: '#6366f1',
                    segment: { borderColor: segmentColor },
                    borderWidth: 1,
                    fill: false,
                    pointRadius: 0,
                    tension: 0.1,
                    spanGaps: false
                }]
            },
            plugins: [targetRangeBandPlugin, midnightLinesPlugin],
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: { legend: { display: false } },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            autoSkip: false,
                            maxRotation: 0,
                            minRotation: 0,
                            font: { size: 9 },
                            callback: (value: any, index: number) => {
                                const inst = this.glucoseChartInstance;
                                const mi: number[] = inst ? (inst as any)._midnightIndices : midnightIndices;
                                const lbls: string[] = inst ? (inst.data.labels as string[]) : labels as string[];
                                if (index === 0 || mi.includes(index)) {
                                    return this.formatGlucoseDayLabel(lbls[index] || '');
                                }
                                return '';
                            }
                        }
                    },
                    y: { min: 40, max: 450, ticks: { stepSize: 50, font: { size: 10 } }, title: { display: true, text: 'mg/dL', font: { size: 11 } } }
                }
            }
        });
        (this.glucoseChartInstance as any)._midnightIndices = midnightIndices;
        this.glucoseChartInstance.update('none');
        this.charts.push(this.glucoseChartInstance);
        await this.service.render();
    }

    private getGlucoseWindow(startDay: number) {
        const endDay = Math.min(startDay + this.glucoseWindowDays, this.glucoseTotalDays);
        const startIdx = this.glucoseDayBounds[startDay]?.startIdx || 0;
        const endIdx = endDay < this.glucoseTotalDays
            ? this.glucoseDayBounds[endDay].startIdx
            : this.glucoseFullRows.length;

        const windowRows = this.glucoseFullRows.slice(startIdx, endIdx);
        const labels = windowRows.map((r: any) => r.t?.substring(0, 16) || '');
        const values = windowRows.map((r: any) => r.g);

        // 모든 날짜 경계(자정)에 구분선 추가 — 예외 없음
        const midnightIndices: number[] = [];
        for (let d = startDay + 1; d < endDay && d < this.glucoseTotalDays; d++) {
            const bound = this.glucoseDayBounds[d] as any;
            const boundaryIndex = bound.startIdx - startIdx;
            if (boundaryIndex > 0 && boundaryIndex < labels.length) {
                midnightIndices.push(boundaryIndex);
            }
        }

        return { labels, values, midnightIndices };
    }

    private formatGlucoseDayLabel(label: string) {
        if (!label || label.length < 10) return '';
        return label.substring(5, 10);
    }

    public async onGlucoseScroll(event: any) {
        const pos = parseInt(event.target.value);
        this.glucoseScrollPos = pos;
        if (!this.glucoseChartInstance) return;

        const { labels, values, midnightIndices } = this.getGlucoseWindow(pos);
        this.glucoseChartInstance.data.labels = labels;
        this.glucoseChartInstance.data.datasets[0].data = values;
        (this.glucoseChartInstance as any)._midnightIndices = midnightIndices;
        this.glucoseChartInstance.update('none');
        await this.service.render();
    }

    public glucoseWindowLabel() {
        if (!this.glucoseDayBounds.length) return '';
        const startDay = this.glucoseDayBounds[this.glucoseScrollPos]?.day || '';
        const endDayIdx = Math.min(this.glucoseScrollPos + this.glucoseWindowDays - 1, this.glucoseTotalDays - 1);
        const endDay = this.glucoseDayBounds[endDayIdx]?.day || '';
        return `${startDay.substring(5)} ~ ${endDay.substring(5)}`;
    }

    // ==============================================
    // 일별 변동성 추이 (SD + TIR dual axis, 최대 30일 윈도우)
    // ==============================================
    private async renderVariabilityChart() {
        if (!this.variabilityChartRef?.nativeElement || this.filledDailyStats.length < 2) return;
        const ctx = this.variabilityChartRef.nativeElement.getContext('2d');

        const windowSize = Math.min(this.filledDailyStats.length, 30);
        this.variabilityScrollMax = Math.max(0, this.filledDailyStats.length - windowSize);
        this.variabilityScrollPos = this.variabilityScrollMax;

        const windowStats = this.filledDailyStats.slice(this.variabilityScrollPos, this.variabilityScrollPos + windowSize);
        const labels = windowStats.map((d: any) => d.date.substring(5));
        const sds = windowStats.map((d: any) => d.sd != null ? d.sd : null);
        const tirs = windowStats.map((d: any) => d.tir_target != null ? d.tir_target : null);

        this.variabilityChartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    { label: 'SD (mg/dL)', data: sds, backgroundColor: 'rgba(99,102,241,0.5)', borderColor: '#6366f1', borderWidth: 1, yAxisID: 'y', order: 2 },
                    { label: 'TIR (%)', data: tirs, type: 'line', borderColor: '#16a34a', borderWidth: 2, backgroundColor: 'transparent', pointRadius: 2, pointBackgroundColor: '#16a34a', yAxisID: 'y1', order: 1, spanGaps: false } as any
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: { legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 10 } } } },
                scales: {
                    x: { ticks: { font: { size: 10 } } },
                    y: { position: 'left', title: { display: true, text: 'SD (mg/dL)', font: { size: 10 } }, ticks: { font: { size: 9 } } },
                    y1: { position: 'right', min: 0, max: 100, title: { display: true, text: 'TIR %', font: { size: 10 } }, ticks: { font: { size: 9 } }, grid: { drawOnChartArea: false } }
                }
            }
        });
        this.charts.push(this.variabilityChartInstance);
        await this.service.render();
    }

    public async onVariabilityScroll(event: any) {
        const pos = parseInt(event.target.value);
        this.variabilityScrollPos = pos;
        if (!this.variabilityChartInstance) return;

        const windowSize = Math.min(this.filledDailyStats.length, 30);
        const windowStats = this.filledDailyStats.slice(pos, pos + windowSize);
        this.variabilityChartInstance.data.labels = windowStats.map((d: any) => d.date.substring(5));
        this.variabilityChartInstance.data.datasets[0].data = windowStats.map((d: any) => d.sd != null ? d.sd : null);
        this.variabilityChartInstance.data.datasets[1].data = windowStats.map((d: any) => d.tir_target != null ? d.tir_target : null);
        this.variabilityChartInstance.update('none');
        await this.service.render();
    }

    public variabilityWindowLabel() {
        if (!this.filledDailyStats.length) return '';
        const windowSize = Math.min(this.filledDailyStats.length, 30);
        const start = this.filledDailyStats[this.variabilityScrollPos]?.date?.substring(5) || '';
        const endIdx = Math.min(this.variabilityScrollPos + windowSize - 1, this.filledDailyStats.length - 1);
        const end = this.filledDailyStats[endIdx]?.date?.substring(5) || '';
        return `${start} ~ ${end}`;
    }

    // ==============================================
    // 일별 TIR (최대 30일 윈도우)
    // ==============================================
    private async renderDailyTirChart() {
        if (!this.dailyTirChartRef?.nativeElement || !this.filledDailyStats.length) return;
        const ctx = this.dailyTirChartRef.nativeElement.getContext('2d');

        const windowSize = Math.min(this.filledDailyStats.length, 30);
        this.dailyTirScrollMax = Math.max(0, this.filledDailyStats.length - windowSize);
        this.dailyTirScrollPos = this.dailyTirScrollMax;

        const tirWindowStats = this.filledDailyStats.slice(this.dailyTirScrollPos, this.dailyTirScrollPos + windowSize);
        const labels = tirWindowStats.map((d: any) => d.date.substring(5));
        const targets = tirWindowStats.map((d: any) => d.tir_target != null ? d.tir_target : null);
        const others = tirWindowStats.map((d: any) => d.tir_target != null ? 100 - d.tir_target : null);

        this.dailyTirChartInstance = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    { label: '목표 범위', data: targets, backgroundColor: '#16a34a' },
                    { label: '범위 밖', data: others, backgroundColor: '#f59e0b' }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: { legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 } } } },
                scales: {
                    x: { stacked: true, ticks: { font: { size: 10 } } },
                    y: { stacked: true, max: 100, ticks: { callback: (v: any) => v + '%', font: { size: 10 } } }
                }
            }
        });
        this.charts.push(this.dailyTirChartInstance);
        await this.service.render();
    }

    public async onDailyTirScroll(event: any) {
        const pos = parseInt(event.target.value);
        this.dailyTirScrollPos = pos;
        if (!this.dailyTirChartInstance) return;

        const windowSize = Math.min(this.filledDailyStats.length, 30);
        const windowStats = this.filledDailyStats.slice(pos, pos + windowSize);
        this.dailyTirChartInstance.data.labels = windowStats.map((d: any) => d.date.substring(5));
        this.dailyTirChartInstance.data.datasets[0].data = windowStats.map((d: any) => d.tir_target != null ? d.tir_target : null);
        this.dailyTirChartInstance.data.datasets[1].data = windowStats.map((d: any) => d.tir_target != null ? 100 - d.tir_target : null);
        this.dailyTirChartInstance.update('none');
        await this.service.render();
    }

    public dailyTirWindowLabel() {
        if (!this.filledDailyStats.length) return '';
        const windowSize = Math.min(this.filledDailyStats.length, 30);
        const start = this.filledDailyStats[this.dailyTirScrollPos]?.date?.substring(5) || '';
        const endIdx = Math.min(this.dailyTirScrollPos + windowSize - 1, this.filledDailyStats.length - 1);
        const end = this.filledDailyStats[endIdx]?.date?.substring(5) || '';
        return `${start} ~ ${end}`;
    }

    // ==============================================
    // Helper: Level badges
    // ==============================================
    public gmiLevel(gmi: number) {
        if (gmi < 7.0) return { label: '양호', cls: 'text-emerald-700 bg-emerald-50' };
        if (gmi < 8.0) return { label: '주의', cls: 'text-yellow-700 bg-yellow-50' };
        return { label: '위험', cls: 'text-red-700 bg-red-50' };
    }

    public cvLevel(cv: number) {
        if (cv < 36) return { label: '안정', cls: 'text-emerald-700 bg-emerald-50' };
        return { label: '불안정', cls: 'text-amber-700 bg-amber-50' };
    }

    public jIndexLevel(j: number) {
        if (j <= 20) return { label: '정상', cls: 'text-emerald-700 bg-emerald-50' };
        if (j <= 40) return { label: '경계', cls: 'text-yellow-700 bg-yellow-50' };
        return { label: '비정상', cls: 'text-red-700 bg-red-50' };
    }

    public lbgiLevel(v: number) {
        if (v <= 2.5) return { label: '낮음', cls: 'text-emerald-700 bg-emerald-50' };
        if (v <= 5) return { label: '중등도', cls: 'text-yellow-700 bg-yellow-50' };
        return { label: '높음', cls: 'text-red-700 bg-red-50' };
    }

    public hbgiLevel(v: number) {
        if (v <= 4.5) return { label: '낮음', cls: 'text-emerald-700 bg-emerald-50' };
        if (v <= 9) return { label: '중등도', cls: 'text-yellow-700 bg-yellow-50' };
        return { label: '높음', cls: 'text-red-700 bg-red-50' };
    }

    public griLevel(v: number) {
        if (v <= 20) return { label: 'A등급 (우수)', cls: 'text-emerald-700 bg-emerald-50' };
        if (v <= 40) return { label: 'B등급 (양호)', cls: 'text-teal-700 bg-teal-50' };
        if (v <= 60) return { label: 'C등급 (보통)', cls: 'text-yellow-700 bg-yellow-50' };
        if (v <= 80) return { label: 'D등급 (주의)', cls: 'text-orange-700 bg-orange-50' };
        return { label: 'E등급 (위험)', cls: 'text-red-700 bg-red-50' };
    }

    public lbgiRiskClass() {
        const v = this.advanced?.lbgi;
        if (v == null) return 'border-zinc-100 bg-zinc-50/50';
        if (v <= 2.5) return 'border-emerald-200 bg-emerald-50/30';
        if (v <= 5) return 'border-yellow-200 bg-yellow-50/30';
        return 'border-red-200 bg-red-50/30';
    }

    public hbgiRiskClass() {
        const v = this.advanced?.hbgi;
        if (v == null) return 'border-zinc-100 bg-zinc-50/50';
        if (v <= 4.5) return 'border-emerald-200 bg-emerald-50/30';
        if (v <= 9) return 'border-yellow-200 bg-yellow-50/30';
        return 'border-red-200 bg-red-50/30';
    }

    public griRiskClass() {
        const v = this.advanced?.gri;
        if (v == null) return 'border-zinc-100 bg-zinc-50/50';
        if (v <= 20) return 'border-emerald-200 bg-emerald-50/30';
        if (v <= 40) return 'border-teal-200 bg-teal-50/30';
        if (v <= 60) return 'border-yellow-200 bg-yellow-50/30';
        return 'border-red-200 bg-red-50/30';
    }

    public targetSd() {
        const mean = this.summary?.statistics?.mean || 0;
        return (mean * 0.36).toFixed(0);
    }

    public mageLevel() {
        const m = this.advanced?.mage;
        if (!m) return '';
        const mean = this.summary?.statistics?.mean || 0;
        if (m < mean * 0.2) return '낮은 변동';
        if (m < mean * 0.4) return '중등 변동';
        return '높은 변동';
    }

    // ==============================================
    // Helper: General
    // ==============================================
    public extractPatientName() {
        const fn = this.upload?.filename || '';
        const parts = fn.split('_');
        if (parts.length >= 3) return parts[2];
        return fn;
    }

    public formatPeriod() {
        if (!this.selectedPeriodStart || !this.selectedPeriodEnd) return '-';
        return this.selectedPeriodStart + ' ~ ' + this.selectedPeriodEnd;
    }

    public formatFullPeriod() {
        const s = this.upload?.period_start;
        const e = this.upload?.period_end;
        if (!s || !e) return '-';
        return s.toString().substring(0, 10) + ' ~ ' + e.toString().substring(0, 10);
    }

    public getPeriodParams(): any {
        const params: any = { id: this.uploadId };
        if (this.periodMode === 'all') return params;
        const pe = (this.upload?.period_end || '').toString().substring(0, 10);
        const ps = (this.upload?.period_start || '').toString().substring(0, 10);
        if (['7d', '14d', '30d', '60d', '90d'].includes(this.periodMode)) {
            const days = parseInt(this.periodMode);
            const endDate = new Date(pe + 'T00:00:00');
            const startDate = new Date(endDate);
            startDate.setDate(startDate.getDate() - days + 1);
            const startStr = startDate.toISOString().substring(0, 10);
            params.start_date = startStr < ps ? ps : startStr;
            params.end_date = pe;
        } else if (this.periodMode === 'custom') {
            params.start_date = this.customStartDate;
            params.end_date = this.customEndDate;
        }
        return params;
    }

    public async setPeriod(mode: string) {
        if (mode === this.periodMode) return;
        this.periodMode = mode;
        this.customApplied = false;
        if (mode === 'custom') {
            await this.service.render();
            return;
        }
        await this.reloadWithPeriod();
    }

    public async applyCustomPeriod() {
        if (!this.customStartDate || !this.customEndDate) return;
        await this.reloadWithPeriod();
        this.customApplied = true;
        await this.service.render();
    }

    private async reloadWithPeriod() {
        this.charts.forEach((c: any) => c.destroy());
        this.charts = [];
        this.glucoseChartInstance = null;
        this.variabilityChartInstance = null;
        this.dailyTirChartInstance = null;

        this.loading = true;
        await this.service.render();

        const params = this.getPeriodParams();

        let [summaryRes, statsRes, eventsRes, advancedRes] = await Promise.all([
            wiz.call("summary", params),
            wiz.call("daily_stats", params),
            wiz.call("events", params),
            wiz.call("advanced", params)
        ]);

        if (summaryRes.code === 200) {
            this.summary = summaryRes.data.summary || {};
            this.filteredDataCount = summaryRes.data.data_count || 0;
            this.selectedPeriodStart = summaryRes.data.period_start || '';
            this.selectedPeriodEnd = summaryRes.data.period_end || '';
        }
        if (statsRes.code === 200) {
            this.dailyStats = statsRes.data.stats || [];
            this.filledDailyStats = this.fillDailyGaps(this.dailyStats);
        }
        if (eventsRes.code === 200) {
            this.hypoEvents = (eventsRes.data.hypo || []).reverse();
            this.hyperEvents = (eventsRes.data.hyper || []).reverse();
        }
        if (advancedRes.code === 200) this.advanced = advancedRes.data.data || {};

        this.loading = false;
        await this.service.render();

        setTimeout(async () => {
            await this.renderTirChart();
            await this.renderHistogramChart();
            await this.renderAgpChart();
            await this.renderHourlyChart();
            await this.renderGlucoseChart();
            await this.renderVariabilityChart();
            await this.renderDailyTirChart();
        }, 100);
    }

    public totalHypoMinutes() {
        return this.hypoEvents.reduce((sum: number, e: any) => sum + (e.duration_min || 0), 0);
    }

    public totalHyperMinutes() {
        return this.hyperEvents.reduce((sum: number, e: any) => sum + (e.duration_min || 0), 0);
    }

    public formatDuration(totalMin: number) {
        const h = Math.floor(totalMin / 60);
        const m = totalMin % 60;
        if (h > 0 && m > 0) return `${h}시간 ${m}분`;
        if (h > 0) return `${h}시간`;
        return `${m}분`;
    }

    public eventPercent(totalMin: number) {
        const totalMonitoringMin = (this.filteredDataCount || 0) * 5;
        if (totalMonitoringMin <= 0) return '0.0';
        return (totalMin / totalMonitoringMin * 100).toFixed(1);
    }

    public get recentDailyStats() {
        return this.dailyStats.slice(-14).reverse();
    }

    public goBack() {
        this.service.href('/dashboard');
    }

    ngOnDestroy() {
        this.charts.forEach((c: any) => c.destroy());
    }
}

export default PageReportComponent;